<template>
    <div>
        <v-icon v-if="result" color="success">check_circle</v-icon>
        <v-icon v-else color="error">error</v-icon>
    </div>
</template>

<script>
export default {
    props: ['result'],
}
</script>

<style>

</style>
